import { render, staticRenderFns } from "./TooltipsModal.vue?vue&type=template&id=1d0a3cbc&scoped=true"
import script from "./TooltipsModal.vue?vue&type=script&lang=js"
export * from "./TooltipsModal.vue?vue&type=script&lang=js"
import style0 from "./TooltipsModal.vue?vue&type=style&index=0&id=1d0a3cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a3cbc",
  null
  
)

export default component.exports